<div class="ctm-arkose-error-dialog">
  <button type="button" class="close-btn" (click)="close()" aria-label="Close">&times;</button>

  <h2 class="fs-24 fw700 text-col3 mb-3">We're unable to process your request</h2>

  <p class="fs-17 text-ctmDefaultText mb-4">
    Our security checks were unable to verify your session. This may happen if you have browser
    extensions that interfere with security checks, or if there was an issue with your session.
  </p>

  <h3 class="fs-17 fw700 text-ctmDefaultText mb-2">What can I do?</h3>
  <ul class="fs-17 text-ctmDefaultText mb-4">
    <li>Try refreshing the page and submitting again</li>
    <li>Disable any browser extensions that may interfere</li>
    <li>Try using a different browser</li>
    <li>Contact our support team if the issue persists</li>
  </ul>

  <hr class="divider" />

  <h3 class="fs-17 fw700 text-ctmDefaultText mb-2">Support reference</h3>
  <dl class="reference-list fs-15 text-ctmSubtleText mb-0">
    <dt>Product</dt>
    <dd>{{ data?.product || 'energy' }}</dd>

    <dt>Reference</dt>
    <dd>{{ reference }}</dd>

    <dt>Session</dt>
    <dd>{{ data?.sessionId }}</dd>

    <dt>Time</dt>
    <dd>{{ time }}</dd>

    <dt>Reason</dt>
    <dd>{{ data?.reason || 'unknown_error' }}</dd>
  </dl>
</div>
